module.exports = __webpack_public_path__ + "img/ticket-immortal.6270bd3d.svg";